import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  Form,
  SectionDivider,
  ActionsWrapper,
  InputPlaceholder
} from "@contently/toolkit";
import ReactPlaceholder from "react-placeholder";
import EnhancedSelect from "../forms/enhanced_select/enhanced_select";
import * as actions from "../../store/actions/index";

export const ReassignUsersForm = props => {
  const {
    handleSubmit,
    options,
    errors,
    touched,
    values,
    fetchStories,
    brandProfileId
  } = props;

  const { fromUser, toUser } = values;

  const usersAreSame = !!fromUser && fromUser.value === toUser.value;

  if (!!fromUser) {
    fetchStories(brandProfileId, fromUser.value);
  }

  const customErrors = usersAreSame
    ? {
        ...errors,
        toUser: "User cannot be the same as the selected user to reassign"
      }
    : errors;

  const customTouched = usersAreSame ? { ...touched, toUser: true } : touched;

  return (
    <form
      onSubmit={handleSubmit}
      data-parsley-excluded="true"
      className="row-half"
    >
      <SectionDivider>
        <div className="interaction">
          <div className="sub-interaction">
            <ReactPlaceholder
              showLoadingAnimation
              customPlaceholder={<InputPlaceholder withLabel />}
              ready={!!options}
            >
              <EnhancedSelect
                {...props}
                selectedValue={values.fromUser}
                setFieldValue={(field, selected, shouldValidate) => {
                  const { setFieldValue } = props;
                  fetchStories(brandProfileId, selected.value);
                  setFieldValue(field, selected, shouldValidate);
                }}
                errors={customErrors.fromUser}
                touched={customTouched.fromUser}
                placeholder="Select a user to reassign"
                label="From user"
                id="fromUser"
                required
              />
            </ReactPlaceholder>
          </div>
          <div className="sub-interaction">
            <ReactPlaceholder
              showLoadingAnimation
              customPlaceholder={<InputPlaceholder withLabel />}
              ready={!!options}
            >
              <EnhancedSelect
                {...props}
                selectedValue={values.toUser}
                errors={customErrors.toUser}
                touched={customTouched.toUser}
                placeholder="Select a user to reassign to"
                label="To user"
                id="toUser"
                required
              />
            </ReactPlaceholder>
          </div>
        </div>
      </SectionDivider>
      <ActionsWrapper>
        <Form.SubmitButton />
      </ActionsWrapper>
    </form>
  );
};

ReassignUsersForm.defaultProps = {
  options: null,
  values: {},
  errors: {},
  touched: {}
};

ReassignUsersForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ),
  setFieldValue: PropTypes.func.isRequired,
  brandProfileId: PropTypes.number.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  fetchStories: PropTypes.func.isRequired,
  values: PropTypes.instanceOf(Object),
  errors: PropTypes.instanceOf(Object),
  touched: PropTypes.instanceOf(Object)
};

const mapDispatchToProps = dispatch => ({
  fetchStories: (bpId, fromId) => dispatch(actions.fetchStories(bpId, fromId))
});

const mapStateToProps = state => ({
  brandProfileId: state.reassignUsers.brandProfileId,
  options: state.reassignUsers.eligibleUsers
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReassignUsersForm);



// WEBPACK FOOTER //
// ./app/javascript/app/components/reassign_users/reassign_users_form.jsx